
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {Appliances} from "@/js/keepRecord/List";
    import {IPage} from "@/js/page";
    import {dictApi, dictInstrumentApi, userApi} from "@/api/organization";
    import {instrumentApi} from "@/api/instrument";
    import SetTableColumns from "@/components/SetTableColumns.vue"
    import AddExamine from "@/components/examine/AddExamine.vue"
    import MeasuringList from "@/components/MeasuringList.vue"
    import {inspectionOrderApi} from "@/api/inspection";
    import { debounced } from '@/common/public.ts'
    import baseUrl, {imageUrl} from "@/constants";
    import {Param} from "@/js/ParamList";
    import InstrSurveyRange from "@/components/InstrSurveyRange.vue";
    const {CodeToText} =require("@/js/region/region");
    const {checkTypeList} = require("@/js/checkType");

    @Component({
        components: {
          InstrSurveyRange,
          MeasuringList, SetTableColumns, AddExamine}
    })
    export default class InstrumentList extends Vue {
        private debouncedUse = debounced.use(this.handleClick, 600)

        title = "器具列表";
        listData = [] as Array<Appliances>;
        CodeToText = CodeToText;
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        listTotal = 0;
        statesList = [];
        tabCol = [];
        allSelected = [] as any;
        allSelectedExamine = [];
        examineNumDialog = false;  //历次检测弹窗
        examineNumList = [];  //检测列表
        recordNumDialog = false;  //历次备案
        recordNumList = [];  //备案列表
        surveyRangesDialog = {
            visible: false,
            paramList: [] as Param[]
        }
        addExamineDialog = false; //添加检测
        instrumentsId = 0; //选择的器具
        form2 = {} as any;
        form2Origin = {

            certificationNumber: "",   //证书编号
            certificateType: "",       //证书类型
            inspectionDate: "",        //检定日期
            expireDate: "",            //有效期
            checkCocn: "",             //检定结论
            checkResult: 1,           //检定状态
            resultText: "",                //检定结果
            basedRuleId: "",           //检定依据
            basedRuleName: "",         //检定依据名称
            reason: "",                //不合格原因
            checkPersonId: "",         //检定员id
            checkPersonName: "",       //检定员姓名
            checkPersonCardCode: "",   //检定员身份证号
            reApproverId: "",          //核验员id
            reApproverName: "",        //核验员姓名
            reApproverCardCode: "",    //核验员身份证号
            approverId: "",            //批准人id
            approverName: "",          //批准人名称
            approverCardCode: "",      //批准人身份证号
            enclosure: "",  //影印件
        }

        load = false;
        moduleText = "/qj";  //跳转用前缀
        tableKey = 0;
        fileListCheck = [] as any;
        baseUrl = baseUrl
        imageUrl = imageUrl
        headers = {Authorization:""}
        form2ShowType = 0;  //检测详情弹窗 2为仅展示
        checkTypeList = checkTypeList;
        specialAddExamine = false; //是否是特殊添加检定档案模式，特殊需要传orderInstrumentsId
        standardDialog = false; // 关联标准弹窗
        standardInstrumentId = 0; // 弹窗打开的器具id
        addRecordBtn = false; //是否展示添加/修改检定记录按钮
        editInstrData = {
          visible: false,
          orderInstrId: "",
          instrumentId: "",
          elements: [],
          prop: {} as any
        }

        /**
         * 查询列表所需额外参数
         * */
        @Prop() private propParams!: any;
        /**
         * 控制展示参数
         * showReport  是否展示表格上报状态
         * showResult  是否展示表格内状态
         * showReason  是否展示不通过原因
         * showVerifierName  是否展示"订单处理人"
         * evaluate    评审按钮展示,器具检定详情充当orderId
         * pageType    0办理 1查看
         * submitBox   展示删除‘本地’列表单挑数据的按钮
         * operationWidth  操作列宽度，没有则不展示操作列
         * hideSelect  隐藏复选列
         * showSelectAudit 展示备案特定的复选框
         * showSelectInspection 展示检定特定的复选框
         * technical   是否是在检定单位任务列表中使用，访问数据的接口不同
         * applyInspection   申请检定列表的器具列表展示
         * showCheckType 是否展示强检器具列
         * examineChange 是否展示检定证书/结果的添加编辑
         * examineShow 是否展示检定证书/结果的查看按钮
         * addExamine 是否展示添加检定档案按钮
         * showCheckAll  是否展示全选按钮
         * showStandard 是否展示关联标准列
         * isAudit 备案添加器具
         * isInspection 检定添加器具
         * useInId 进入详情使用instrumentId
         * */
        @Prop() private propOption!: any;
        /**
         * 列表展示数据，会跳过接口请求
         * */
        @Prop() private dataSource!: any;
        //父级控制“初始”分页专用
        @Prop() private propPage!: any;

        @Watch("propParams")
        getpropParams(n: any, o: any) {
            if(JSON.stringify(n) != JSON.stringify(o)){
                if (this.propParams.isAudit || this.propParams.isInspection) {
                    this.list();
                } else {
                    this.refresh();
                }
            }
        }
        @Watch("dataSource")
        getdataSource(n: any, o: any) {
            if(JSON.stringify(n) != JSON.stringify(o)){
                this.listParam.current = 1;
                this.handleClick();
            }
        }

        created() {
            this.getConfig();
            this.getDict(7);
            const arr = this.$route.path.split('/');
            if(arr.length > 1 && arr[1] != 'home'){
                this.moduleText = '/'+arr[1];
            }
        }

        indexMethods(index: number) {
            return (this.examineNumList.length - index)
        }

        refresh() {
            this.listParam.current = 1;
            this.debouncedUse();
        }

        closeSurveyRangesDialog() {
            this.surveyRangesDialog.paramList = [] as Param[];
            this.surveyRangesDialog.visible = false;
        }

        closeExamineList(){
            this.examineNumDialog = false;
            this.examineNumList = [];
            this.allSelectedExamine = [];
            // this.debouncedUse();
        }

        getConfig() {
            userApi.getUserConfig({name: "instrumentPageSize"}).then(r => {
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    if (rData) {
                        this.listParam.size = Number(rData.config);
                    }
                    if(this.propPage){
                        this.listParam.current = this.propPage.current;
                        this.listParam.size = this.propPage.size;
                        this.list();
                    }else{
                        this.list();
                    }
                }
            })
        }
        indexMethod(index: any) {
            return (this.listParam.current-1)*this.listParam.size+index+1;
        }

        handleClick(){
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            $table.clearSelection();
            this.list();
        }

        toggleSelection(rows: any) {
            let $table = this.$refs.table as HTMLFormElement;
            if (rows) {
                rows.forEach((row: any) => {
                    $table.toggleRowSelection(row);
                });
            } else {
                $table.clearSelection();
            }
            this.allSelected = rows;
        }

        imgList(){
            for(const l of this.listData){
                const imglist = l.imgPath;
                if(imglist){
                    try {
                        l.imgPathArr = JSON.parse(imglist);
                    } catch (e) {
                        console.log('转json失败'+imglist)
                        l.imgPathArr = [];
                    }
                }else{
                    l.imgPathArr = [];
                }
            }
        }
        list() {
            if (this.dataSource) {
                this.listData = this.dataSource;
                this.listTotal = this.dataSource.length;
                this.imgList();
                return;
            }
            this.load = true;
            const params = {
                ...this.propParams,
                ...this.listParam,
            }
            const typeCode = this.$route.query.typeCode;

            if(typeCode){
              params.typeName = typeCode;
            }
            if(params.checkType === "" || params.checkType === undefined){
                params.checkType = params.checkType2;
            }
            this.$emit("instrumentParam", params);
            let api;
            if(this.propOption.technical){
                params.mode = 2;
                api = inspectionOrderApi.listInspectionOrderInstruments(params);
            }else if(this.propOption.applyInspection){
                params.mode = 1;
                api = inspectionOrderApi.listInspectionOrderInstruments(params);
            }else{
                api = instrumentApi.list(params);
            }
            api.then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    this.listTotal = r.data.data.total;
                    this.listData = [];
                    for (const r of rData) {
                        r.showTooltip = false;
                        this.listData.push(new Appliances(r));
                    }
                    this.imgList();
                    this.$nextTick(()=>{
                        let $table = this.$refs.table as HTMLFormElement;
                        if($table){
                            $table.clearSelection();
                            $table.doLayout();
                        }
                        this.checkThisPageData();
                    })
                }
                this.load = false;
            })
        }

        getDict(category: number, code: string | string = "") {
            return dictApi.list({
                category: category,
                code: code
            }).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    if (category == 7) {
                        this.statesList = rData;
                    }
                }
            })
        }
        checkboxInit(row: any,index: number) {
            if(row.result){
                return 0;//0不可勾选
            }else{
                return 1;//1可勾选
            }
        }
        checkboxInitInspection(row: any,index: number){
            //备案状态:已接收 2，检定状态：已检定，已超期，未检定  1,5,0  自动分配
            //已接收 2，  未受理 3     选检测机构
            //免备案 5，  已检定，已超期，未检定 1,5,0   选检定机构
            //免备案 5，  未受理 3   选检定机构
            let r = 1;
            if(this.allSelected && this.allSelected.length > 0){
                const selected = this.allSelected[0] as any;
                const checkR = selected.checkResult.value;
                const checkType = selected.checkType;
                if(this.mutexCheck(checkR, checkType) !== this.mutexCheck(row.checkResult.value, row.checkType)){
                    r = 0;
                }
            }
            return r;
        }
        //互斥勾选判断
        mutexCheck(checkResult: number, checkType: number){
            let type = 0;
            if((checkResult === 1 || checkResult === 5 || checkResult === 0) && checkType === 2){
                type = 1;
            }else if(checkResult === 3 && checkType === 2){
                type = 2;
            }else if((checkResult === 1 || checkResult === 5 || checkResult === 0) && checkType === 5){
                type = 3;
            }else if(checkResult === 3 && checkType === 5){
                type = 4;
            }
            return type;
        }

        //备案的判断
        checkboxInitAudit(row: any,index: number){
            if(row.result){
                if (row.result.value)
                    return 0;//0不可勾选
                else
                    return 1;//1可勾选
            }else{
                return 1;//1可勾选
            }
        }
        //检定受理判断
        checkboxInitEvaluate(row: any,index: number){
            if(row.checkResult){
                if (row.checkResult.value == 3 || row.checkResult.value == 8)
                    return 0;//0不可勾选
                else
                    return 1;//1可勾选
            }else{
                return 1;//1可勾选
            }
        }
        //检定办理列表的检定器具选项卡
        checkboxInitTechnical(row: any,index: number){
            return 1
        }
        checkboxInit2(row: any,index: number){
            if(row.strong == 1 && row.purposeCode != "9"){
                return 1;//0不可勾选
            }else{
                return 0;//1可勾选
            }
        }
        checkboxInit2Title(e:any){
            let str = "";
            if(e.strong == 0 && e.purposeCode != "9"){
                str = "不允许勾选不在强检计量器具目录内的器具";
            }else if(e.strong != 0 && e.purposeCode == "9"){
                str = "不允许勾选不符合强检计量器具规定用途的器具";
            }else if(e.strong == 0 && e.purposeCode == "9"){
                str = "不允许勾选不在强检计量器具目录内，或不符合强检计量器具规定用途的器具";
            }
            return str;
        }
        // 检定器具不允许勾选的提示
        checkboxInit3Title(row:any){
            let str = "";
            if(this.allSelected && this.allSelected.length > 0){
                const selected = this.allSelected[0] as any;
                const checkR = selected.checkResult.value;
                const checkType = selected.checkType;
                str = "计量器具报检时，是否允许同时报检与计量器具的“备案状态”和“检定状态”有关";
            }
            return str;
        }
        calcCheckTypeVal(e:any){
            return e.checkType;
        }
        showCheckTypeStr(e:any){
            let str = "";
            const obj = this.checkTypeList.find((e2: any)=>e2.id == e.checkType);
            if(obj){
                str = obj.name;
            }else {
                str = '-';
            }
            return str;
        }
        showTooltip(row: any){
            if(this.propOption.addAudit && (row.strong == 0 || row.purposeCode == "9")){
                row.showTooltip = true;
            }
            if(this.propOption.showSelectInspection && this.checkboxInit3Title(row) != ""){
                row.showTooltip = true;
            }
        }
        hideTooltip(row: any) {
            row.showTooltip = false;
        }

        statesText(states: number) {
            let text = "暂无";
            const obj = this.statesList.find((e: any) => e.code == states) as any;
            if (obj) {
                text = obj.name;
            }
            return text;
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.listParam.current = 1;
            this.list();
            userApi.updateUserConfig({name: "instrumentPageSize", config: val})
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.list();
        }

        edit(data: any) {
            this.$router.push(this.moduleText+"/instrument/detail/1/" + data.id);
        }

        detail(data: any) {
            let id = data.id;
            //检定单位任务列表中的器具id不同
            if(this.propOption.technical || this.propOption.applyInspection || this.propOption.useInId){
                id = data.instrumentId;
            }
            this.$router.push(this.moduleText+"/instrument/detail/2/" + id);
        }
        //result 2 未通过  1通过  3 查看
        evaluate(data: any, result: number, submitForm: number | undefined = 0){
            if(result != 3 && !(this.propOption.technical || this.propOption.applyInspection)){
                this.$router.push(this.moduleText+"/instrument/detail/2/" + data.instrumentId + "?result="+result+"&orderInstrumentsId="+data.id+"&submitForm="+1);
                return
            }
            this.$router.push(this.moduleText+"/instrument/detail/2/" + data.instrumentId + "?result="+result+"&orderInstrumentsId="+data.id+"&submitForm="+submitForm+"&orderId="+this.propOption.evaluate+"&checkResult="+data.checkResult.value);
        }
        //result 1
        auditBtn(data: any, result: number){
            this.$router.push(this.moduleText+"/instrument/detail/2/" + data.id + "?auditResult="+result+"&orderInstrumentsId="+this.propOption.auditBox);
        }

        del(data: any) {
            this.$confirm('确定要删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                instrumentApi.delete({id: data.id}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        if (this.listData.length == 1 && this.listParam.current > 1) {
                            this.listParam.current--;
                        }
                        this.handleClick();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }

        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(()=>{
                let $table = this.$refs.table as HTMLFormElement;
                if($table){
                    $table.doLayout();
                }
                this.tableKey = Math.random();
            })
        }
        memberSelectAll(selections: any){
            this.memberSelect(selections);
        }
        memberSelect(selections: any) {
            let allSelected = [];
            if(this.propOption && this.propOption.showSelectInspection && selections.length > 0){
                const selected = selections[0];
                const flag = this.mutexCheck(selected.checkResult.value, selected.checkType)
                allSelected = selections.filter((row: any) => flag === this.mutexCheck(row.checkResult.value, row.checkType));
            }else{
                allSelected = selections;
            }
            this.allSelected = allSelected;
            let $table = this.$refs.table as HTMLFormElement;
            $table.clearSelection();
            allSelected.forEach((row: any) => {
                $table.toggleRowSelection(row);
            });
        }
        getCheckId() {
            const ids = this.allSelected.flatMap((e: any) => e.id);
            return ids;
        }
        getCheckData() {
            return JSON.parse(JSON.stringify(this.allSelected));
        }
        //当前查看检定结果列表的，选中的器具数据
        showExamineListActiveInstrumentData = null as any;
        showExamineList(row: any){
            this.instrumentsId = row.instrumentId?row.instrumentId:row.id;
            this.showExamineListActiveInstrumentData = row;
            this.showExamineList2();
        }
        showExamineList2(){
            this.hasAddCheckRecord();
            inspectionOrderApi.listOrderByInstrumentId({instrumentsId: this.instrumentsId}).then(r=>{
                if(r.data.result == 0){
                    const rData = r.data.data;
                    this.examineNumList = rData;
                    this.examineNumDialog = true;
                }
            })
        }
        showRecordList(row: any){
            instrumentApi.getAuditDetails({id: row.instrumentId?row.instrumentId:row.id}).then(r=>{
                if(r.data.result == 0){
                    const rData = r.data.data;
                    this.recordNumList = rData;
                    this.recordNumDialog = true;
                    this.$nextTick(() => {
                        let $table = this.$refs.recordNumTable as HTMLFormElement;
                        if ($table) {
                            $table.doLayout();
                        }
                    })
                }
            })
        }
        addExamineDialogBtn(){
            this.addExamineDialog = true;
            this.specialAddExamine = false;
            this.form2 = {};
            this.fileListCheck = [];
        }
        parseParamList(jsonString: string){
            if(jsonString){
                return JSON.parse(jsonString);
            }

        }
        //0新增  1编辑 2查看  3删除
        editExamine(type: number) {
            const dataArr = this.allSelectedExamine as any;
            if(type !== 0){
                if(dataArr.length == 0){
                    this.$message.error("请先勾选");
                    return;
                }
                if(type == 3){
                    this.delExamineBtn(dataArr);
                    return;
                }
                if(dataArr.length > 1 && (type == 1 || type == 2)){
                    this.$message.error("只能勾选一条");
                    return;
                }
              if(type == 1 && (dataArr[0].orderId !== 0) && this.propOption.addExamine){
                this.$message.error("档案来源为【检定流程】，请去【检定申请-待办器具】界面进行办理");
                return;
              }
                //自动的 已受理 已具证 可以编辑， 手动的都能编辑
                if((dataArr[0].checkResult.value != 8 && dataArr[0].checkResult.value != 11 ) && (dataArr[0].orderId !== 0) && type == 1){
                    this.$message.error("检定状态为【"+dataArr[0].checkResult.text+"】，不得编辑");
                    return;
                }
                this.editExamineDialogBtn(dataArr[0]);
            }else{
                this.addExamineDialogBtn();
            }
            this.form2ShowType = type;
        }
        //编辑
        editExamineDialogBtn(data: any){
            const r = JSON.parse(JSON.stringify(data));
            this.addExamineDialog = true;
            this.specialAddExamine = true;
            r.checkResult = r.checkResult.value;
            r.basedRuleId = r.basedRuleId === 0 ? "" : r.basedRuleId;
            this.form2 = Object.assign(JSON.parse(JSON.stringify(this.form2Origin)), r);
            if(this.form2.enclosure){
                this.fileListCheck = [];
                try {
                    var obj=JSON.parse(this.form2.enclosure);
                    if(typeof obj == 'object' && obj ){
                        for(let i = 0; i < obj.length; i++){
                            this.fileListCheck.push({name: obj[i].name ,url: imageUrl+obj[i].url})
                        }
                    }
                } catch(e) {
                    const arr = this.form2.enclosure.split(",");
                    for(let i = 0; i < arr.length; i++){
                        this.fileListCheck.push({name:"证书文件",url: imageUrl+arr[i]})
                    }
                }
            }
        }
        //删除
        delExamineBtn(dataArr: any){
            this.$confirm('确定要删除'+dataArr.flatMap((e:any)=>e.certificationNumber).join(",")+'？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                inspectionOrderApi.deleteInspectionOrderInstruments({ids: dataArr.flatMap((e:any)=>e.id).join(","), instrumentId: this.instrumentsId}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        const obj = this.listData.find((e: any)=>e.instrumentId?e.instrumentId:e.id == this.instrumentsId) as any;
                        if(obj){
                            obj.examineNum--;
                        }
                        this.handleClickExamine();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }
        hasAddCheckRecord(){
          inspectionOrderApi.hasAddCheckRecord(this.instrumentsId).then((r: any) => {
              if(r.data.result === 0){
                this.addRecordBtn = r.data.data;
              }
          });
        }
        hasBtn(mode: string){
          if(mode === 'record-add'){
            return this.propOption.addExamine && this.addRecordBtn;
          }else if(mode === 'record-edit'){
            return (this.propOption.addExamine || this.propOption.examineChange) && this.showExamineListActiveInstrumentData;
          }
        }
        handleClickExamine() {
            this.allSelectedExamine = [];
            let $table = this.$refs.tableExamine as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
            this.showExamineList2();
        }
        memberSelectExamine(selection: any, row: any) {
            this.allSelectedExamine = selection;
        }

        clostDialog() {
            this.addExamineDialog = false;
            if(this.propOption.technical || this.propOption.applyInspection){
                this.handleClick();
            }
            if(this.examineNumDialog){
                this.handleClickExamine();
            }
            if(this.specialAddExamine){
                this.handleClick();
            }
        }
        //删除本地数据的单条
        delData(index: number){
            this.dataSource.splice(index,1);
        }
        down(row: any) {
            try {
                var obj=JSON.parse(row);
                if(typeof obj == 'object' && obj ){
                    window.open(baseUrl + "/file/download?file=" + obj[0].url + "&name=" + obj[0].name, '_blank');
                    return true;
                }else{
                    return false;
                }
            } catch(e) {
                window.open(baseUrl + "/file/download?file=" + row + "&name=影印件", '_blank');
                return false;
            }
        }

        filesuffix(fileName: string) {
            const first = fileName.lastIndexOf(".");//取到文件名开始到最后一个点的长度
            const namelength = fileName.length;//取到文件名长度
            const filesuffix = fileName.substring(first + 1, namelength);//截取获得后缀名
            return filesuffix;
        }

        openSurveyRangesDialog(surveyRanges: string) {
            this.surveyRangesDialog.paramList = this.parseParamList(surveyRanges);
            this.surveyRangesDialog.visible = true;
        }
        //全选，根据查询条件获取
        checkAllBtn(){
            let $table = this.$refs.table as HTMLFormElement;
            // $table.toggleRowSelection(this.listData[0]);
            const params = {
                ...this.propParams,
                ...this.listParam,
            }
            if(params.checkType === "" || params.checkType === undefined){
                params.checkType = params.checkType2;
            }
            if(this.propOption.technical){
                params.mode = 2;
            }else if(this.propOption.applyInspection){
                params.mode = 1;
            }
            inspectionOrderApi.listInspectionOrderInstrumentIds(params).then((r: any) => {
                if (r.data.result === 0) {
                    this.allSelected = [];
                    const rData = r.data.data;
                    for(const rd of rData){
                        const obj = this.listData.find((e:any)=>e.instrumentId == rd);
                        if(obj){
                            this.allSelected.push(obj);
                            $table.toggleRowSelection(obj);
                        }else{
                            this.allSelected.push({instrumentId: rd});
                        }
                    }
                }
            });
        }

        //勾选当前页需要勾选的数据
        checkThisPageData(){
            let $table = this.$refs.table as HTMLFormElement;
            this.listData.forEach((e: any)=>{
                const index = this.allSelected.findIndex((e2:any)=>e2.instrumentId == e.instrumentId);
                if(index != -1 && !this.allSelected[index].id){
                    this.allSelected.splice(index, 1, e);
                    $table.toggleRowSelection(e);
                }
            })
        }

        lookData(row: any){
          const {dictInstrumentId, instrumentId, data, id} = row;
          dictInstrumentApi.getOne({id: dictInstrumentId}).then((r: any) => {
            if(r.data.result === 0) {
              const rData = r.data.data;
              this.editInstrData.elements = rData.data ? JSON.parse(rData.data)  : [];
              if(this.editInstrData.elements.length === 0){
                this.$message.warning("本器具暂不支持设置此数据！");
                return;
              }
              this.editInstrData.orderInstrId = id;
              this.editInstrData.instrumentId = instrumentId;
              this.editInstrData.prop = JSON.parse(data) || {};
              this.editInstrData.visible = true;
            }
          });
        }
        saveData(){
          const {orderInstrId, instrumentId, prop} = this.editInstrData;
          inspectionOrderApi.saveData(orderInstrId, instrumentId, JSON.stringify(prop)).then((r: any) => {
              if(r.data.result === 0){
                this.closeEditInstr();
                this.clostDialog();
                this.$message.success("保存成功！");
              }
          });
        }
        closeEditInstr(){
          this.editInstrData.visible = false;
          this.editInstrData.elements = [];
          this.editInstrData.instrumentId = "";
          this.editInstrData.prop = {};
        }
        getTableType(){
            if(this.propParams.isAudit || this.propParams.isInspection){
                return "InstrumentV2";
            }else{
                return "instrument";
            }
        }
    }
